import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

export default function RadioButtonWithLabel({
  hideLabel = false,
  id,
  className,
  value,
  checked,
  label,
  onChange,
  disabled,
  tabIndex,
}) {
  const theme = useContext(ThemeContext);

  const inputElement = () => {
    return (
      <input
        checked={checked}
        className="radio-button__input"
        disabled={disabled}
        id={id}
        onChange={onChange}
        tabIndex={tabIndex}
        type="radio"
        value={value}
      />
    );
  };

  if (hideLabel) return <>{inputElement()}</>;

  return (
    <>
      <label
        className={classNames(
          'radio-button',
          { 'radio-button--is-active': checked },
          className,
        )}
      >
        <span className="radio-button__label">{label}</span>
        {inputElement()}
      </label>
      <style jsx>{`
        .radio-button {
          font-size: 14px;
          font-weight: normal;
          background-color: ${theme.colors.checkoutmodulebg};
          color: ${theme.colors.bodytext};
          display: flex;
          align-items: center;
          padding: 6px 10px;
          margin-bottom: 0;
          position: relative;
          border-radius: 5px;
          border: 1px solid transparent;
          cursor: pointer;
        }
        .radio-button--boxed {
          border: 1px solid #cccccc;
        }
        .radio-button--is-active {
          font-weight: bold;
          border-color: ${theme.colors.infoboxborder};
          background-color: ${theme.colors.infoboxbg};
        }
        .radio-button__input {
          appearance: none;
          width: 13px;
          height: 13px;
          border-radius: 50%;
          margin: 0 !important;
          position: absolute;
          top: 9px;
          right: 12px;
          border: 1px solid ${theme.colors.bodytext};
          box-shadow: 0 2px 3px 0 ${theme.colors.dropshadow} inset;
          cursor: pointer;
        }
        .radio-button__input:checked {
          border-width: 4px;
          border-color: ${theme.colors.infoboxborder};
          box-shadow: none;
          background-color: ${theme.colors.checkoutmodulebg};
        }
        .radio-button__input:focus {
          outline: none !important;
        }
        .radio-button__input:disabled {
          opacity: 0.4;
        }
        .radio-button--switch .radio-button__label {
          padding-left: 28px;
          text-align: center;
          flex-grow: 1;
        }
        .radio-button--switch .radio-button__input {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
        .radio-button__radio-before-label {
          flex-direction: row-reverse;
        }
        .radio-button--green {
          border-color: ${theme.colors.successboxborder};
          background-color: ${theme.colors.successboxbg};
        }
      `}</style>
    </>
  );
}

RadioButtonWithLabel.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  tabIndex: PropTypes.number,
  value: PropTypes.any,
};
